import { Box, Checkbox, IconButton, Modal } from "@mui/material";
import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import cssClasses from "./CancellationBankDetails.module.css";
import { useState } from "react";
import Button from "../../Subcomponents/Button";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { getCustomerLedgerId } from "../../Services/Bank";
import { errorTost } from "../../Services/Toast";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const ViewAcceptDetailsModal = ({
  open,
  handleClose,
  bookAppData,
  handleSaveAndAccept,
  panBankData,
  isAlreadyAccepted,
  selectedBankDetails,
}) => {
  const [checked, setChecked] = useState([]);
  const [customerLedgerData, setCustomerLedgerData] = useState([]);

  useEffect(() => {
    getAllCustomersLedgerIds();
  }, []);

  const getAllCustomersLedgerIds = () => {
    presentLoader();
    panBankData.forEach((val) => {
      getCustomerLedgerId(val?.booking.ledger.Code.toString())
        .then((resp) => {
          setCustomerLedgerData((pre) => {
            const payload = {
              ...resp?.data[0],
              applicationId: val?.application?.Id,
              customerId: val?.customer?.Id,
              applicationLedgerId: val?.booking.ledger.Id,
              description: val?.booking?.ledger.Description,
            };
            return [...pre, payload];
          });
          dismissLoader();
        })
        .catch((err) => {
          errorTost(err.message);
          dismissLoader();
        });
    });
  };

  return (
    <Modal
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.acceptModalWrapper}>
        <div className={cssClasses.header}>
          <h1>{isAlreadyAccepted ? "View Ledger Updates" : "Select Ledger"}</h1>
          <IconButton
            className={cssClasses.crossButton}
            onClick={() => handleClose(false)}
          >
            {" "}
            <CloseIcon />{" "}
          </IconButton>
        </div>

        <div
          style={{
            margin: "3rem 5rem 0rem 5rem",
            paddingLeft: "2rem",
            fontSize: "1.7rem",
            fontFamily: "Inter-SemiBold",
          }}
        >
          Application
        </div>
        <div className={cssClasses.acceptDetailsWrapper}>
          {panBankData.map((value) => {
            return (
              <div className={cssClasses.radioWrapper}>
                {isAlreadyAccepted ? (
                  selectedBankDetails?.RefundFormUpdateLedgerResp.filter(
                    (val) =>
                      val.applicationLedgerId ===
                        value?.booking?.ledger?.Id.toString() &&
                      val?.applicationLedgerRes
                  )?.length > 0 ? (
                    <CheckCircleOutlineIcon
                      style={{
                        color: "#32D583",
                        width: "3rem",
                        height: "6rem",
                      }}
                    />
                  ) : selectedBankDetails?.RefundFormUpdateLedgerResp.filter(
                      (val) =>
                        val.applicationLedgerId ===
                          value?.booking?.ledger?.Id.toString() &&
                        !val?.applicationLedgerRes
                    )?.length > 0 ? (
                    <HighlightOffIcon
                      style={{ color: "red", width: "3rem", height: "6rem" }}
                    />
                  ) : (
                    <ErrorOutlineIcon
                      style={{
                        color: "#FEC84B",
                        width: "3rem",
                        height: "6rem",
                      }}
                    />
                  )
                ) : (
                  <Checkbox
                    style={{
                      width: "2rem",
                      height: "2rem",
                      transform: "scale(2)",
                    }}
                    checked={
                      checked.filter(
                        (val) =>
                          val.ledgerId === value.booking.ledger.Id &&
                          val.customerId === value.customer.Id &&
                          val?.applicationId === value.application.Id
                      ).length > 0
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      const payload = [...checked];
                      if (e.target.checked) {
                        payload.push({
                          ledgerId: value?.booking.ledger.Id,
                          customerId: value?.customer?.Id,
                          applicationId: value.application.Id,
                        });
                        setChecked(payload);
                      } else {
                        const index = checked.findIndex(
                          (val) =>
                            val.ledgerId === value?.booking.ledger.Id &&
                            val?.applicationId === value.application.Id
                        );
                        payload.splice(index, 1);
                        setChecked(payload);
                      }
                    }}
                  />
                )}
                <span style={{ fontFamily: "inter-Regular" }}>
                  <span style={{ fontFamily: "inter-semibold" }}>
                    Ledger Id :
                  </span>{" "}
                  {value.booking.ledger.Id}
                </span>
                <span style={{ fontFamily: "inter-Regular" }}>
                  <span style={{ fontFamily: "inter-semibold" }}>
                    Ledger Name :
                  </span>{" "}
                  {value.booking.ledger.Description}
                </span>

                <span style={{ fontFamily: "inter-Regular" }}>
                  <span style={{ fontFamily: "inter-semibold" }}>
                    Customer Id :
                  </span>{" "}
                  {value.customer.Id}
                </span>

                <span style={{ fontFamily: "inter-Regular" }}>
                  <span style={{ fontFamily: "inter-semibold" }}>
                    Application Id :
                  </span>{" "}
                  {value.application.Id}
                </span>
              </div>
            );
          })}

          <div
            style={{
              margin: "0rem",
              paddingLeft: "2rem",
              fontSize: "1.7rem",
              fontFamily: "Inter-SemiBold",
            }}
          >
            Customer
          </div>

          {customerLedgerData.map((value) => {
            return (
              <div className={cssClasses.radioWrapper}>
                {isAlreadyAccepted ? (
                  selectedBankDetails?.RefundFormUpdateLedgerResp.filter(
                    (val) =>
                      val.applicationLedgerId ===
                        value?.applicationLedgerId?.toString() &&
                      val?.applicationLedgerRes
                  )?.length > 0 ? (
                    <CheckCircleOutlineIcon
                      style={{
                        color: "#32D583",
                        width: "3rem",
                        height: "6rem",
                      }}
                    />
                  ) : selectedBankDetails?.RefundFormUpdateLedgerResp.filter(
                      (val) =>
                        val.applicationLedgerId ===
                          value?.applicationLedgerId?.toString() &&
                        !val?.applicationLedgerRes
                    )?.length > 0 ? (
                    <HighlightOffIcon
                      style={{ color: "red", width: "3rem", height: "6rem" }}
                    />
                  ) : (
                    <ErrorOutlineIcon
                      style={{
                        color: "#FEC84B",
                        width: "3rem",
                        height: "6rem",
                      }}
                    />
                  )
                ) : (
                  <Checkbox
                    style={{
                      width: "2rem",
                      height: "2rem",
                      transform: "scale(2)",
                    }}
                    checked={
                      checked.filter(
                        (val) => val?.applicationId === value.applicationId
                      ).length > 0
                        ? true
                        : false
                    }
                    onChange={(e) => {}}
                    disabled
                  />
                )}
                <span style={{ fontFamily: "inter-Regular" }}>
                  <span style={{ fontFamily: "inter-semibold" }}>
                    Ledger Id :
                  </span>{" "}
                  {value.bookingId}
                </span>
                <span style={{ fontFamily: "inter-Regular" }}>
                  <span style={{ fontFamily: "inter-semibold" }}>
                    Ledger Name :
                  </span>{" "}
                  {value.description}
                </span>

                <span style={{ fontFamily: "inter-Regular" }}>
                  <span style={{ fontFamily: "inter-semibold" }}>
                    Customer Id :
                  </span>{" "}
                  {value.customerId}
                </span>

                <span style={{ fontFamily: "inter-Regular" }}>
                  <span style={{ fontFamily: "inter-semibold" }}>
                    Application Id :
                  </span>{" "}
                  {value.applicationId}
                </span>
              </div>
            );
          })}

          {!isAlreadyAccepted && (
            <div
              className={cssClasses.footer}
              style={{ padding: "2rem 0 2rem 2rem" }}
            >
              <div>
                <Button
                  style={{
                    color: "rgb(255, 255, 255)",
                    backgroundColor: "rgb(0, 106, 255)",
                  }}
                  btnName={"Run Update Ledger APIs"}
                  disable={checked?.length === 0}
                  clicked={() => {
                    const payload = [];
                    checked.forEach((val) =>
                      payload.push({
                        ledgerId: val.ledgerId,
                        applicationId: val?.applicationId,
                      })
                    );
                    handleSaveAndAccept(payload);
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default ViewAcceptDetailsModal;
